import { Component } from '@angular/core';

@Component({
  selector: 'tun-account-icon',
  templateUrl: './account-icon.component.html'
})
export class AccountIconComponent { }
